'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthInterceptorService = function () {
  function AuthInterceptorService($q, $injector) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AuthInterceptorService);
    this.$q = $q;
    this.$injector = $injector;

    return {
      request: this.request.bind(this),
      responseError: this.responseError.bind(this)
    };
  }

  (0, _createClass3.default)(AuthInterceptorService, [{
    key: 'request',
    value: function request(config) {
      config.headers = config.headers || {};

      if (config.url.includes('http') && !config.url.includes('login')) {
        var authService = this.$injector.get('authService');

        if (authService.isLoggedIn()) {
          var authData = JSON.parse(sessionStorage.getItem('authData'));
          if (authData) {
            config.headers.Authorization = 'Bearer ' + authData.authToken;
          }
        }
      }

      return config;
    }
  }, {
    key: 'responseError',
    value: function responseError(rejection) {
      if (rejection.status === 401 || rejection.status === 404) {
        var authService = this.$injector.get('authService');
        authService.unauthorized();
      }

      if (rejection.status === 403) {
        var _authService = this.$injector.get('authService');
        _authService.unauthorized(rejection.data.message);
      }

      return this.$q.reject(rejection);
    }
  }]);
  return AuthInterceptorService;
}();

exports.default = AuthInterceptorService;


// WEBPACK FOOTER //
// ./client/app/common/services/authInterceptorService.js